import { CustomerManagerCompany } from '@model';
import {
  CustomerManagerCompaniesActions,
  CustomerManagerCompaniesActionTypes
} from '@appStore/customers/actions/customer-manager-companies.actions';

export interface State {
  loaded: boolean;
  loading: boolean;
  data: CustomerManagerCompany[];
  deleiting: boolean;
  deleted: boolean;
  updating: boolean;
  updated: boolean;
}

export const initialState: State = {
  data: [],
  loaded: false,
  loading: false,
  deleiting: false,
  deleted: false,
  updating: false,
  updated: false
};

export function reducer(state = initialState, action: CustomerManagerCompaniesActions): State {
  switch (action.type) {
    case CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadData:
      return { ...state, loading: true, loaded: false };
    case CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadSuccess:
      return {
        ...state,
        data: action.payload,
        loading: false,
        loaded: true
      };
    case CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadFail:
      return {
        ...state,
        data: [],
        loading: false,
        loaded: false
      };
    case CustomerManagerCompaniesActionTypes.CreateCustomerManagerCompanySuccess:
      return { ...state, loaded: true, loading: false, data: [...state.data, action.payload] };

    case CustomerManagerCompaniesActionTypes.DeleteCustomerManagerCompany:
      return { ...state, deleiting: true, deleted: false };
    case CustomerManagerCompaniesActionTypes.DeleteCustomerManagerCompanySuccess:
      const removedItem = action.payload;
      return {
        ...state,
        deleted: true,
        deleiting: false,
        data: state.data.filter(item => item.id !== removedItem.id)
      };

    case CustomerManagerCompaniesActionTypes.UpdateCustomerManagerCompany:
      return { ...state, updating: true, updated: false };
    case CustomerManagerCompaniesActionTypes.UpdateCustomerManagerCompanySuccess:
      const updatedItem = action.payload;
      return {
        ...state,
        updated: true,
        updating: false,
        data: state.data.map(item =>
          item.id === updatedItem.id && item.customerId === updatedItem.customerId ? updatedItem : item
        )
      };
  }
  return state;
}

export const getCustomerManagerCompanies = (state: State) => state.data;
export const getCustomerManagerCompaniesLoading = (state: State) => state.loading;
export const getCustomerManagerCompaniesLoaded = (state: State) => state.loaded;
export const getCustomerManagerCompanyDeleted = (state: State) => state.deleted;
export const getCustomerManagerCompanyUpdated = (state: State) => state.updated;
